export function threadListParams({ facet, workspaceScope, q } = {}) {
  const params = {}
  if (facet && facet !== 'all') params.facet = facet
  if (workspaceScope && workspaceScope !== 'current') params.workspace_scope = workspaceScope
  const query = String(q ?? '').trim()
  if (query) params.q = query.slice(0, 200)
  return params
}
